export default {
  details: 'Details',
  category: 'Category',
  ['parent-category']: '古典文学',
};
